/* global google */
import React, { useEffect, useState, useRef } from "react";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import {
  TerraDraw,
  TerraDrawSelectMode,
  TerraDrawPolygonMode,
  TerraDrawRectangleMode,
  TerraDrawCircleMode,
} from "terra-draw";

import {
  TerraDrawGoogleMapsAdapter,
} from "terra-draw-google-maps-adapter";
import { FaPlus, FaArrowLeft } from "react-icons/fa";
import InfoReferencia from "../../components/InfoReferencia";
import { Modal, Box } from "@mui/material";
import "./styles.scss";
import "react-toastify/dist/ReactToastify.css";
import { loadGoogleMaps } from "../../utils/googleMapsLoader"
import { IoIosArrowBack } from "react-icons/io";

import { IoMdArrowDropup } from "react-icons/io";
import { MdAddLocationAlt } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoTrashOutline } from "react-icons/io5";
import {
  MdLocationOn,
  MdAltRoute,
  MdCropSquare,
  MdCheck,
  MdEdit,
} from "react-icons/md";



import Swal from "sweetalert2";


// const google = (window.google = window.google ? window.google : {});


var markers = [];
var drawingManager;
var selectedShape;
var colors = ["#1E90FF", "#FF1493", "#32CD32", "#FF8C00", "#4B0082"];
var selectedColor = colors[0]; //  ESSENCIAL
// var selectedColor;
var colorButtons = {};
var desenhos = [];
var drawnShapes = [];   //  desenho atual (usuario)
var loadedShapes = [];  //  backend
//var mapEvent;
var marker1, marker2, polyline;
var ArrayPoints = [];
export var array_forms = [];
var array_routes = [];

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};


//função deletar
export const confirmDelete = async (ref, handleDelete) => {

  // ===============================================================================================
  // CONFIRMAÇÃO
  // ===============================================================================================

  const result = await Swal.fire({

    background: "#0b1724",

    color: "#ffffff",

    width: "400px",

    padding: "30px",

    showCancelButton: true,

    reverseButtons: true,

    confirmButtonText: "Excluir",

    cancelButtonText: "Cancelar",

    buttonsStyling: false,

    customClass: {

      popup: "swal-delete-modern",

      actions: "swal-actions-modern",

      confirmButton: "swal-btn-delete",

      cancelButton: "swal-btn-cancel"

    },

    html: `

      <div class="swal-delete-content">

        <!-- =========================================================
             ÍCONE
        ========================================================== -->

        <div class="swal-delete-icon">

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.8"
          >

            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="
                M6 7h12
                M9 7V4h6v3
                M10 11v6
                M14 11v6
                M5 7l1 13h12l1-13
              "
            />

          </svg>

        </div>


        <!-- =========================================================
             TÍTULO
        ========================================================== -->

        <h2 class="swal-delete-title">
          Excluir referência?
        </h2>


        <!-- =========================================================
             DESCRIÇÃO
        ========================================================== -->

        <p class="swal-delete-description">
          Esta ação removerá permanentemente
          a referência selecionada.
        </p>


        <!-- =========================================================
             REFERÊNCIA
        ========================================================== -->

        <div class="swal-delete-box">

          <span class="swal-delete-label">
            REFERÊNCIA
          </span>

          <div class="swal-delete-name">
            ${ref.nome_referencia}
          </div>

        </div>

      </div>

    `
  });


  // ===============================================================================================
  // CANCELADO
  // ===============================================================================================

  if (!result.isConfirmed) {
    return;
  }


  // ===============================================================================================
  // LOADING
  // ===============================================================================================

  Swal.fire({

    html: `

      <div class="swal-loading-content">

        <!-- =========================================================
             LOADER
        ========================================================== -->

        <div class="swal-loading-icon">

          <div class="swal-loading-spinner"></div>

        </div>


        <!-- =========================================================
             TÍTULO
        ========================================================== -->

        <div class="swal-loading-title">
          Apagando referência...
        </div>


        <!-- =========================================================
             SUBTÍTULO
        ========================================================== -->

        <div class="swal-loading-subtitle">
          Processando exclusão
        </div>

      </div>

    `,

    showConfirmButton: false,

    allowOutsideClick: false,

    allowEscapeKey: false,

    background: "#0b1724",

    color: "#ffffff",

    width: "360px",

    padding: "30px",

    customClass: {

      popup: "swal-loading-modern"

    }

  });


  try {

    // =============================================================================================
    // DELETE
    // =============================================================================================

    const sucesso = await handleDelete(ref.id);


    // =============================================================================================
    // EXCLUSÃO BLOQUEADA / ERRO TRATADO
    // =============================================================================================

    if (!sucesso) {

      // O handleDelete já mostrou a mensagem.
      // Não mostra sucesso.

      return;

    }


    // =============================================================================================
    // SUCESSO
    // =============================================================================================

    Swal.fire({

      html: `

        <div class="swal-success-content">

          <!-- =======================================================
               ÍCONE
          ======================================================== -->

          <div class="swal-success-icon">

            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >

              <path d="M20 6L9 17L4 12"/>

            </svg>

          </div>


          <!-- =======================================================
               TÍTULO
          ======================================================== -->

          <div class="swal-success-title">
            Exclusão realizada
          </div>


          <!-- =======================================================
               SUBTÍTULO
          ======================================================== -->

          <div class="swal-success-subtitle">
            A referência foi removida com sucesso.
          </div>

        </div>

      `,

      timer: 1400,

      showConfirmButton: false,

      background: "#0b1724",

      color: "#ffffff",

      width: "360px",

      padding: "30px",

      customClass: {

        popup: "swal-success-modern"

      }

    });


  } catch (error) {

    // =============================================================================================
    // ERRO
    // =============================================================================================

    console.error(
      "ERRO NO CONFIRM DELETE:",
      error
    );


    Swal.fire({

      icon: "error",

      title: "Erro ao apagar",

      text:
        error?.response?.data?.message ||
        "Tente novamente.",

      background: "#0b1724",

      color: "#ffffff",

      width: "360px",

      padding: "30px",

      customClass: {

        popup: "swal-delete-modern"

      }

    });

  }

};






function PolygonsMaps() {
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [editData, setEditData] = useState(null);

  const [editingShape, setEditingShape] = useState(null);
  const mapRef = useRef(null);
  const savedRoutesRef = useRef({});
  const savedRouteBlinkRef = useRef(null);

  const mapContainerRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);

  const [editingId, setEditingId] = useState(null);
  const terraDrawRef = useRef(null);
  const tipoDesenhoRef = useRef(null);



  //iniciar mapa
  const [subT, setSubT] = useState({});
  const [values, setValues] = useState({ descricao: "" });
  const [centerLng, setCenterLng] = useState({});
  const [centerLat, setCenterLat] = useState({});
  const [referencias, setRerefencias] = useState([]);
  const [isList, setIsList] = useState(false); // false = list, true = add route
  const [flagAdd, setFlagAdd] = useState(true); // Flag to know if happened a Add or delete route action
  const [pathRoutes, setPathRoutes] = useState("");
  const [inputs, setInputs] = useState(["", ""]);
  const [isRouteGenarete, setIsRouteGenarete] = useState(false); // false = not genarete, true = generate
  const [color, setColor] = useState("red");

  const colorRef = useRef("red");
  const [routeColor, setRouteColor] = useState("#2563eb");
  const [valuesStatus, setValuesStatus] = useState([]);
  const [valuesIndexStatus, setValuesIndexStatus] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [referenciasSearchTerm, setReferenciasSearchTerm] = useState("");
  const routeMarkersRef = useRef([]);
  const routeBlinkIntervalRef = useRef(null);
  const routePreviewMarkersRef = useRef([]);
  const [confirmRef, setConfirmRef] = useState({
    nome_referencia: "",
    id: null,
  });
  const [aberto, setAberto] = useState(false);
  const [isArea, setIsArea] = useState(false);


  const [mapLoaded, setMapLoaded] = useState(false);
  //ESTDOS DE EXIBIÇÃO DA ROTA
  const directionsRendererRef = useRef(null);
  const directionsServiceRef = useRef(null);
  const polylineRef = useRef(null);
  const [shape, setShape] = useState("");
  const [carregandoAreasRotas, setCarregandoAreasRotas] = useState(true);
  function selectColor(color) {
    selectedColor = color;
    for (var i = 0; i < colors.length; ++i) {
      var currColor = colors[i];
      colorButtons[currColor].style.border = currColor === color ? "2px solid #919191" : "1px solid #fff";
    }



    var rectangleOptions = drawingManager.get("rectangleOptions");
    rectangleOptions.fillColor = color;
    drawingManager.set("rectangleOptions", rectangleOptions);

    var circleOptions = drawingManager.get("circleOptions");
    circleOptions.fillColor = color;
    drawingManager.set("circleOptions", circleOptions);

    var polygonOptions = drawingManager.get("polygonOptions");
    polygonOptions.fillColor = color;
    drawingManager.set("polygonOptions", polygonOptions);
  }



  //========================================
  // PIN COLORIDO ROTA
  //========================================
  const criarPinColorido = (cor) => {
    const svg = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="52"
      viewBox="0 0 42 52"
    >
      <defs>
        <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow
            dx="0"
            dy="2"
            stdDeviation="2"
            flood-opacity="0.35"
          />
        </filter>
      </defs>

      <path
        d="M21 1C9.95 1 1 9.95 1 21
           C1 35 21 51 21 51
           C21 51 41 35 41 21
           C41 9.95 32.05 1 21 1Z"
        fill="${cor}"
        stroke="#ffffff"
        stroke-width="2"
        filter="url(#shadow)"
      />

      <circle
        cx="21"
        cy="21"
        r="7"
        fill="#ffffff"
      />
    </svg>
  `;

    return {
      url:
        "data:image/svg+xml;charset=UTF-8," +
        encodeURIComponent(svg),

      scaledSize: new window.google.maps.Size(32, 40),

      anchor: new window.google.maps.Point(16, 40),
    };
  };


  //========================================
  // ROTA PISCANDO
  //========================================
  const iniciarPulsoRota = () => {
    if (routeBlinkIntervalRef.current) {
      clearInterval(routeBlinkIntervalRef.current);
    }

    let visible = true;

    routeBlinkIntervalRef.current = setInterval(() => {
      visible = !visible;

      // LINHA
      if (polylineRef.current) {
        polylineRef.current.setOptions({
          strokeOpacity: visible ? 1 : 0.25,
        });
      }

      // PINS
      routeMarkersRef.current.forEach((marker) => {
        if (marker) {
          marker.setOpacity(visible ? 1 : 0.25);
        }
      });

    }, 900);
  };






  function setSelectedShapeColor(color) {
    if (selectedShape) {
      if (selectedShape.type === google.maps.drawing.OverlayType.POLYLINE) {
        selectedShape.set("strokeColor", color);
      } else {
        selectedShape.set("fillColor", color);
      }
    }
  }
  function makeColorButton(color) {
    var button = document.createElement("span");
    button.className = "color-button";
    button.style.backgroundColor = color;
    google.maps.event.addDomListener(button, "click", function () {
      selectColor(color);
      setSelectedShapeColor(color);
    });

    return button;
  }


  function buildColorPalette() {





    var colorPalette = document.getElementById("color-palette");
    if (!colorPalette) return;
    colorPalette.innerHTML = ""; // limpa antes (evita duplicar)

    for (var i = 0; i < colors.length; ++i) {
      var currColor = colors[i];
      var colorButton = makeColorButton(currColor);
      colorPalette.appendChild(colorButton);
      colorButtons[currColor] = colorButton;
    }
    selectColor(colors[0]);
  }


  function clearSelection() {
    if (selectedShape) {
      if (selectedShape.type !== "marker") {
        selectedShape.setEditable(false);
      }

      selectedShape = null;
    }
  }
  function setSelection(shape) {
    if (shape.type !== "marker") {
      clearSelection();
      shape.setEditable(true);
      selectColor(shape.get("fillColor") || shape.get("strokeColor"));
    }

    selectedShape = shape;
  }
  function showMarker() {
    if (markers.length != 0) {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }
      markers = [];
    }
  }
  function addInput() {
    if (inputs.length <= 17) {
      setInputs([...inputs, ""]);
    }
  }
  function handleColorChange(event) {
    const novaCor = event.target.value;

    console.log("🎨 COR SELECIONADA PELO USUÁRIO:", novaCor);

    // Atualiza o React
    setColor(novaCor);

    // Guarda a cor atual imediatamente
    colorRef.current = novaCor;

    console.log(
      "🎨 COLOR REF ATUAL:",
      colorRef.current
    );
  }


  //=======================================
  //BOTAO DORPDOWN LISTA DE PONTOS E AREAS
  //=======================================
  const toggleDropdown = () => {
    setAberto(!aberto);
  };









  // INICIA O MAPA
  useEffect(() => {
    const initMap = () => {
      const mapDiv = mapContainerRef.current;
      const bounds = {
        north: -23.5,   // topo
        south: -23.9,   // baixo
        west: -47.1,    // esquerda
        east: -46.6     // direita
      };

      if (!mapDiv) {
        console.log(" mapDiv null");
        return;
      }

      if (mapRef.current instanceof window.google.maps.Map) return;

      mapRef.current = new window.google.maps.Map(mapDiv, {
        center: { lat: -23.6821604, lng: -46.8754848 },
        zoom: 10,
        minZoom: 3,
        mapTypeControl: false,
        gestureHandling: "greedy",
        drawingControl: false,


        restriction: {
          latLngBounds: {
            north: 80,
            south: -80,
            west: -179.8,
            east: 179.8,
          },
          strictBounds: true,
        }



      });

      console.log(" MAPA CRIADO");
      // =========================================================
      // TERRA DRAW
      // =========================================================
      mapRef.current.addListener("projection_changed", () => {

        console.log("🗺️ PROJEÇÃO DO MAPA PRONTA");

        // Impede criar duas instâncias do Terra Draw
        if (terraDrawRef.current) {
          console.log("⚠️ TERRA DRAW JÁ EXISTE");
          return;
        }

        try {

          terraDrawRef.current = new TerraDraw({

            adapter: new TerraDrawGoogleMapsAdapter({
              map: mapRef.current,
              lib: window.google.maps,
              coordinatePrecision: 9,
            }),

            modes: [

              new TerraDrawSelectMode({
                flags: {

                  polygon: {
                    feature: {
                      draggable: true,

                      coordinates: {
                        draggable: true,
                        midpoints: true
                      }
                    }
                  },

                  rectangle: {
                    feature: {
                      draggable: true,

                      coordinates: {
                        draggable: true,
                        midpoints: true
                      }
                    }
                  },

                  circle: {
                    feature: {
                      draggable: true,

                      coordinates: {
                        draggable: true,
                        midpoints: true
                      }
                    }
                  }

                }
              }),

              new TerraDrawPolygonMode({
                styles: {
                  fillColor: "#3b82f6",
                  fillOpacity: 0.35,
                  outlineColor: "#3b82f6",
                  outlineOpacity: 1,
                  outlineWidth: 2,
                },
              }),

              new TerraDrawRectangleMode({
                styles: {
                  fillColor: "#3b82f6",
                  fillOpacity: 0.35,
                  outlineColor: "#3b82f6",
                  outlineOpacity: 1,
                  outlineWidth: 2,
                },
              }),

              new TerraDrawCircleMode({
                styles: {
                  fillColor: "#3b82f6",
                  fillOpacity: 0.35,
                  outlineColor: "#3b82f6",
                  outlineOpacity: 1,
                  outlineWidth: 2,
                },
              }),

            ],

          });

          terraDrawRef.current.start();

          console.log("🟢 TERRA DRAW INICIADO");


          // =========================================================
          // FINALIZAÇÃO DO DESENHO
          // =========================================================

          terraDrawRef.current.on("finish", (id, context) => {
            console.log("=================================");
            console.log("🏁 FINISH");
            console.log("🆔 ID:", id);
            console.log("📦 CONTEXT:", context);

            // =========================================================
            // PEGA O SNAPSHOT ATUAL
            // =========================================================

            const snapshot = terraDrawRef.current.getSnapshot();

            console.log("📸 SNAPSHOT NO FINISH:", snapshot);

            const desenho = snapshot.find(
              (feature) => feature.id === id
            );

            console.log("🔎 FEATURE ENCONTRADA:", desenho);

            if (!desenho) {
              console.error("❌ DESENHO NÃO ENCONTRADO NO SNAPSHOT");
              return;
            }

            console.log("🟢 GEOMETRIA:", desenho.geometry);

            // =========================================================
            // GUARDA SOMENTE 1 DESENHO
            // =========================================================

            const corAtual = colorRef.current;

            console.log(
              "🎨 COR NO MOMENTO DO FINISH:",
              corAtual
            );

            drawnShapes = [
              {
                feature: desenho,
                type: tipoDesenhoRef.current,
                color: corAtual,
              },
            ];

            console.log(
              "💾 DRAWNSHAPES:",
              drawnShapes
            );
            console.log("💾 DRAWNSHAPES:", drawnShapes);

            // =========================================================
            // MARCA QUE JÁ EXISTE UMA ÁREA
            // =========================================================

            setDesenhoCriado(true);

            // =========================================================
            // MUITO IMPORTANTE:
            // SAI DO MODO DE DESENHO
            // =========================================================

            if (terraDrawRef.current) {
              terraDrawRef.current.setMode("static");

              console.log(
                "🔒 DESENHO BLOQUEADO — MODO:",
                terraDrawRef.current.getMode()
              );
            }

            console.log("=================================");
          });







        } catch (error) {

          console.error(
            "❌ ERRO AO INICIAR TERRA DRAW:",
            error
          );

        }

      });








      console.log("🟢 TERRA DRAW INICIADO");










      setMapLoaded(true);

      console.log("🟢 MAPA LIBERADO PARA CARREGAR ÁREAS E ROTAS");



    };

    loadGoogleMaps().then(() => {
      initMap();
    });
  }, []);

  //========================================
  // DESTACA ROTA EXISTENTE
  //=======================================

  const destacarRota = (rotaId) => {

    console.log("🔦 Destacando rota:", rotaId);

    const rota = savedRoutesRef.current[rotaId];

    if (!rota) {
      console.warn("⚠️ Rota não encontrada:", rotaId);
      console.log("Rotas disponíveis:", savedRoutesRef.current);
      return;
    }

    const { polyline, markers } = rota;

    // Cancela um destaque anterior
    if (savedRouteBlinkRef.current) {
      clearInterval(savedRouteBlinkRef.current);
      savedRouteBlinkRef.current = null;
    }

    // Garante que a rota esteja visível
    polyline.setMap(mapRef.current);

    markers.forEach((marker) => {
      if (marker) {
        marker.setMap(mapRef.current);
      }
    });

    // ============================================
    // PISCAR A ROTA EXISTENTE
    // ============================================

    let contador = 0;
    let visivel = true;

    savedRouteBlinkRef.current = setInterval(() => {

      visivel = !visivel;
      contador++;

      polyline.setOptions({
        strokeOpacity: visivel ? 1 : 0.25,
        strokeWeight: visivel ? 6 : 4,
      });

      markers.forEach((marker) => {
        if (marker) {
          marker.setOpacity(visivel ? 1 : 0.25);
        }
      });

      // 12 alterações = aproximadamente 1,2 segundo
      if (contador >= 16) {

        clearInterval(savedRouteBlinkRef.current);
        savedRouteBlinkRef.current = null;

        // Volta ao estado normal
        polyline.setOptions({
          strokeOpacity: 1,
          strokeWeight: 4,
        });

        markers.forEach((marker) => {
          if (marker) {
            marker.setOpacity(1);
          }
        });

      }

    }, 450);
  };



  // BUSCA ROTAS ATIVAS NO MAPA
  async function fetchRotas(data = null) {












    // Se não recebeu os dados, busca no backend
    if (!data) {
      const response = await api.get("/referenciass", {
        headers: {
          inova: localStorage.getItem("inova"),
        },
      });

      data = response.data;
      console.log("🛣️ fetchRotas recebeu:", data);
    }

    let rotas = data.filter((obj) => {

      const tipo = String(obj.tipo || "")
        .trim()
        .toLowerCase();

      const ativo =
        obj.ativo === true ||
        obj.ativo === "true" ||
        obj.ativo === 1 ||
        obj.ativo === "1" ||
        obj.ativo === "t";

      return tipo === "rota" && ativo;
    });
    console.log("🛣️ ROTAS ATIVAS ENCONTRADAS:", rotas);
    console.log("🛣️ QUANTIDADE DE ROTAS:", rotas.length);

    // ===============================================================================================
    // LIMPA ROTAS ANTIGAS
    // ===============================================================================================

    if (array_routes.length > 0) {

      for (let i = 0; i < array_routes.length; i++) {

        if (array_routes[i] instanceof window.google.maps.InfoWindow) {
          array_routes[i].close();

        } else if (array_routes[i]) {
          array_routes[i].setMap(null);
        }
      }

      array_routes.length = 0;
    }

    savedRoutesRef.current = {};


    rotas.forEach((rota, index) => {

      // =====================================================
      // COR DA ROTA
      // =====================================================

      const corRota = rota.cor || "#2563eb";

      console.log("🛣️ ROTA:", rota.descricao);
      console.log("🎨 COR SALVA:", corRota);

      // =====================================================
      // COORDENADAS AUXILIARES
      // =====================================================

      let northCoordinates = [];

      if (rota.north) {

        try {

          // remove {{ }}
          const cleaned = rota.north
            .replace(/^{{/, "")
            .replace(/}}$/, "");

          // separa pontos
          const points = cleaned.split("},{");

          northCoordinates = points.map((coord) => {

            const [lat, lng] = coord
              .replace("{", "")
              .replace("}", "")
              .split(",");

            return {
              lat: parseFloat(lat),
              lng: parseFloat(lng),
            };
          });

          console.log(
            "PARADAS:",
            northCoordinates
          );

        } catch (error) {

          console.error(
            "Erro ao processar paradas:",
            error
          );
        }
      }





      // =============================================================================================
      // POLYLINE
      // =============================================================================================

      if (!rota.obj_google) {
        console.warn(
          "⚠️ Rota sem obj_google:",
          rota.id,
          rota.descricao
        );

        return;
      }

      let str_waypoints = String(rota.obj_google)
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .split("|");

      let poliline = str_waypoints
        .map((val) => {
          const valor = val.split(",");

          return {
            lat: parseFloat(valor[0]),
            lng: parseFloat(valor[1]),
          };
        })
        .filter(
          (coord) =>
            Number.isFinite(coord.lat) &&
            Number.isFinite(coord.lng)
        );

      if (poliline.length < 2) {
        console.warn(
          "⚠️ Rota sem coordenadas suficientes:",
          rota.id,
          rota.descricao,
          rota.obj_google
        );

        return;
      }

      // =============================================================================================
      // LINHA DA ROTA
      // =============================================================================================

      const polyline = new window.google.maps.Polyline({
        path: poliline,
        strokeColor: rota.cor,
        strokeOpacity: 1,
        strokeWeight: 4,
        map: mapRef.current,
      });

      array_routes.push(polyline);


      // MARKERS QUE PERTENCEM A ESSA ROTA
      const markersRota = [];

      // =============================================================================================
      // MARCADOR INÍCIO
      // =============================================================================================


      const startMarker = new window.google.maps.Marker({
        position: poliline[0],
        map: mapRef.current,
        icon: criarPinColorido(corRota),
        zIndex: 101,
      });

      markersRota.push(startMarker);

      // =============================================================================================
      // MARCADOR FINAL
      // =============================================================================================

      const endMarker = new window.google.maps.Marker({
        position: poliline[poliline.length - 1],
        map: mapRef.current,
        icon: criarPinColorido(corRota),
        zIndex: 101,
      });

      markersRota.push(endMarker);

      array_routes.push(startMarker);
      array_routes.push(endMarker);

      // =============================================================================================
      // INFO INÍCIO
      // =============================================================================================

      const startInfo = new window.google.maps.InfoWindow({
        content: `
        <div class="custom-route-label start">
          <div class="route-title">
            ${rota.descricao}
          </div>
        </div>
      `,
        disableAutoPan: true,
      });

      // =============================================================================================
      // INFO FINAL
      // =============================================================================================

      const endInfo = new window.google.maps.InfoWindow({
        content: `
        <div class="custom-route-label end">
          <div class="route-title">
            ${rota.descricao}
          </div>

          <div class="route-subtitle">
            FIM
          </div>
        </div>
      `,
        disableAutoPan: true,
      });

      array_routes.push(startInfo);
      array_routes.push(endInfo);

      // =============================================================================================
      // HOVER INÍCIO
      // =============================================================================================

      startMarker.addListener("mouseover", () => {
        startInfo.open(mapRef.current, startMarker);
      });

      startMarker.addListener("mouseout", () => {
        startInfo.close();
      });

      // =============================================================================================
      // HOVER FINAL
      // =============================================================================================

      endMarker.addListener("mouseover", () => {
        endInfo.open(mapRef.current, endMarker);
      });

      endMarker.addListener("mouseout", () => {
        endInfo.close();
      });

      // =============================================================================================
      // HOVER LINHA DA ROTA
      // =============================================================================================

      polyline.addListener("mouseover", (e) => {

        startInfo.setPosition(e.latLng);

        startInfo.open({
          map: mapRef.current,
        });
      });

      polyline.addListener("mouseout", () => {
        startInfo.close();
      });

      // =============================================================================================
      // PONTOS AUXILIARES
      // =============================================================================================
      northCoordinates.forEach((coord, index) => {

        const marker =
          new window.google.maps.Marker({

            position: coord,

            map: mapRef.current,

            title:
              index === 0
                ? "Origem"
                : index === northCoordinates.length - 1
                  ? "Destino"
                  : `Parada ${index}`,

            icon: criarPinColorido(corRota),
          });

        array_routes.push(marker);

        // Guarda esse marker dentro da rota
        markersRota.push(marker);
      });

      // =============================================================================================
      // GUARDA A ROTA JÁ CRIADA
      // =============================================================================================

      savedRoutesRef.current[rota.id] = {
        polyline,
        markers: markersRota,
      };
    });

    console.log(" ARRAY_ROUTES:", array_routes);
  }



  // ===============================================================================================
  // CARREGA ÁREAS + ROTAS
  // ===============================================================================================
  const carregarAreasERotas = async () => {

    const inicioLoading = Date.now();

    // Ativa o loader
    setCarregandoAreasRotas(true);

    // Dá tempo para o React renderizar o loader na tela
    await new Promise((resolve) =>
      setTimeout(resolve, 50)
    );

    try {

      console.log("🚀 Carregando áreas e rotas...");

      const { data } = await api.get("/referenciass", {
        headers: {
          inova: localStorage.getItem("inova"),
        },
      });

      console.log("📦 REFERÊNCIAS RECEBIDAS:", data);
      console.log("📊 TOTAL RECEBIDO:", data?.length);

      // =========================================================
      // REMOVE PONTOS
      // =========================================================

      const referenciasSemPontos = data.filter(
        (item) => item.tipo !== "ponto"
      );

      console.log(
        "🧹 REFERÊNCIAS SEM PONTOS:",
        referenciasSemPontos
      );

      console.log(
        "📊 TOTAL SEM PONTOS:",
        referenciasSemPontos.length
      );

      // =========================================================
      // REFERÊNCIAS
      // =========================================================

      setRerefencias(referenciasSemPontos);

      // =========================================================
      // STATUS
      // =========================================================

      setValuesStatus(
        referenciasSemPontos.map(
          (item) => item.ativo
        )
      );

      setValuesIndexStatus(
        referenciasSemPontos.map(
          (item) => item.id
        )
      );

      // =========================================================
      // ÁREAS ATIVAS
      // =========================================================

      const ativos = referenciasSemPontos.filter((item) => {

        const ativo =
          item.ativo === true ||
          item.ativo === "true" ||
          item.ativo === 1 ||
          item.ativo === "1" ||
          item.ativo === "t";

        return (
          ativo &&
          item.apagado_em == null
        );

      });

      console.log(
        "🟢 ITENS ATIVOS:",
        ativos
      );

      console.log(
        "🟢 TOTAL ATIVOS:",
        ativos.length
      );

      setFormasAtivas(ativos);

      // =========================================================
      // DESENHA ÁREAS
      // =========================================================

      try {

        console.log(
          "🎨 Iniciando desenho das áreas..."
        );

        DrawFormas(ativos);

        console.log(
          "✅ Áreas desenhadas!"
        );

      } catch (error) {

        console.error(
          "❌ ERRO AO DESENHAR ÁREAS:",
          error
        );

      }

      // =========================================================
      // DESENHA ROTAS
      // =========================================================

      try {

        console.log(
          "🛣️ Iniciando desenho das rotas..."
        );

        await fetchRotas(data);

        console.log(
          "✅ Rotas desenhadas!"
        );

      } catch (error) {

        console.error(
          "❌ ERRO AO DESENHAR ROTAS:",
          error
        );

      }

      console.log(
        "🏁 Processo de áreas e rotas finalizado!"
      );

    } catch (error) {

      console.error(
        "❌ ERRO AO CARREGAR REFERÊNCIAS:",
        error
      );

    } finally {

      console.log(
        "🏁 Finalizando loader"
      );

      // =========================================================
      // GARANTE PELO MENOS 1 SEGUNDO DE LOADING
      // =========================================================

      const tempoDecorrido = Date.now() - inicioLoading;

      const tempoRestante = Math.max(
        0,
        1000 - tempoDecorrido
      );

      if (tempoRestante > 0) {

        await new Promise((resolve) =>
          setTimeout(resolve, tempoRestante)
        );

      }

      setCarregandoAreasRotas(false);
    }
  };


  useEffect(() => {
    if (mapLoaded && isArea) {
      setTimeout(() => {
        buildColorPalette();
      }, 100); // espera renderizar o form
    }
  }, [mapLoaded, isArea]);


  //busca as rotas
  useEffect(() => {

    console.log("=================================");
    console.log("🔎 USEEFFECT ÁREAS/ROTAS");
    console.log("mapLoaded:", mapLoaded);
    console.log("mapRef.current:", mapRef.current);
    console.log("google:", window.google);
    console.log("google.maps:", window.google?.maps);
    console.log("=================================");

    if (!mapLoaded) {
      console.log("⛔ Parou: mapLoaded = false");
      return;
    }

    if (!mapRef.current) {
      console.log("⛔ Parou: mapRef.current não existe");
      return;
    }

    if (!window.google) {
      console.log("⛔ Parou: window.google não existe");
      return;
    }

    console.log("🚀 VAI CHAMAR carregarAreasERotas()");

    carregarAreasERotas();

  }, [mapLoaded]);





  //========================================
  // BUSCA ENDEREÇO NO MAPA
  //========================================
  useEffect(() => {

    if (!inputs || !isList) return;

    const searchBoxes = [];

    for (let i = 0; i < inputs.length; i++) {

      const input =
        document.getElementById(`searchBox-${i}`);

      if (!input) continue;

      const searchBox =
        new window.google.maps.places.SearchBox(input);

      searchBox.addListener("places_changed", () => {

        const places = searchBox.getPlaces();

        if (!places || !places.length) return;

        const place = places[0];

        if (!place.geometry?.location) return;

        const lat =
          place.geometry.location.lat();

        const lng =
          place.geometry.location.lng();

        const position = {
          lat,
          lng
        };

        console.log("📍 ENDEREÇO SELECIONADO:", place.name);
        console.log("📍 COORDENADAS:", position);

        // =====================================================
        // GUARDA COORDENADA
        // =====================================================

        ArrayPoints[i] = position;

        setSubT([...ArrayPoints]);

        // =====================================================
        // MOVE MAPA
        // =====================================================

        if (mapRef.current) {

          mapRef.current.panTo(position);

          mapRef.current.setZoom(17);

        }

        // =====================================================
        // REMOVE PIN ANTERIOR DESTE CAMPO
        // =====================================================

        if (routePreviewMarkersRef.current[i]) {

          routePreviewMarkersRef.current[i].setMap(null);

        }

        // =====================================================
        // CRIA PIN DE PREVIEW
        // =====================================================

        const marker =
          new window.google.maps.Marker({

            position,

            map: mapRef.current,

            title:
              place.formatted_address ||
              place.name ||
              "Local selecionado",

            icon: criarPinColorido(routeColor),

            zIndex: 999,

          });

        routePreviewMarkersRef.current[i] =
          marker;

        // =====================================================
        // PULSO DO PIN
        // =====================================================

        let visible = true;

        const pulse = setInterval(() => {

          if (!marker.getMap()) {

            clearInterval(pulse);

            return;

          }

          visible = !visible;

          marker.setOpacity(
            visible ? 1 : 0.3
          );

        }, 900);

      });

      searchBoxes.push(searchBox);

    }

    return () => {

      searchBoxes.forEach((searchBox) => {

        window.google.maps.event.clearInstanceListeners(
          searchBox
        );

      });

    };

  }, [inputs, isList, routeColor]);




  //EXIBINDO ROTA
  useEffect(() => {
    if (!window.google || !window.google.maps || !mapRef.current) return;

    directionsRendererRef.current = new window.google.maps.DirectionsRenderer();
    directionsServiceRef.current = new window.google.maps.DirectionsService();

    directionsRendererRef.current.setMap(mapRef.current);
  }, [mapRef.current]);


  // FUNÇÃO GERAR ROTA NO MAPA 
  async function calcRoute() {
    if (!ArrayPoints || ArrayPoints.length < 2) {
      console.error("Pontos insuficientes");
      return;
    }

    const directionsRenderer = directionsRendererRef.current;
    const directionsService = directionsServiceRef.current;

    if (!directionsRenderer || !directionsService) return;

    // =====================================================
    // LIMPA ROTA ANTIGA
    // =====================================================

    if (polylineRef.current) {
      polylineRef.current.setMap(null);
      polylineRef.current = null;
    }

    // Limpa animação anterior
    if (routeBlinkIntervalRef.current) {
      clearInterval(routeBlinkIntervalRef.current);
      routeBlinkIntervalRef.current = null;
    }

    // Remove pins antigos
    routeMarkersRef.current.forEach((marker) => {
      if (marker) {
        marker.setMap(null);
      }
    });

    routeMarkersRef.current = [];

    // =====================================================
    // WAYPOINTS
    // =====================================================

    const waypts = ArrayPoints.slice(1, -1);

    const way_points = waypts.map((point) => ({
      location: point,
    }));

    // =====================================================
    // REQUEST DA ROTA
    // =====================================================

    const request = {
      origin: ArrayPoints[0],
      destination: ArrayPoints[ArrayPoints.length - 1],
      waypoints: way_points,
      travelMode: window.google.maps.TravelMode.DRIVING,
    };

    directionsService.route(request, function (result, status) {
      if (status !== window.google.maps.DirectionsStatus.OK) {
        console.error("Erro ao gerar rota:", status);
        return;
      }

      const route = result.routes[0];

      // =====================================================
      // LINHA DA ROTA
      // =====================================================

      polylineRef.current = new window.google.maps.Polyline({
        path: route.overview_path,
        strokeColor: routeColor,
        strokeOpacity: 1,
        strokeWeight: 5,
        map: mapRef.current,
        zIndex: 100,
      });

      // =====================================================
      // CRIA PIN PARA CADA PONTO DA ROTA
      // =====================================================

      ArrayPoints.forEach((point, index) => {
        let titulo = "Parada";

        if (index === 0) {
          titulo = "Origem";
        } else if (index === ArrayPoints.length - 1) {
          titulo = "Destino";
        } else {
          titulo = `Parada ${index}`;
        }

        const marker = new window.google.maps.Marker({
          position: point,
          map: mapRef.current,
          title: titulo,
          icon: criarPinColorido(routeColor),
          zIndex: 101,
        });

        routeMarkersRef.current.push(marker);
      });

      // =====================================================
      // ENQUADRA A ROTA NO MAPA
      // =====================================================

      const bounds = new window.google.maps.LatLngBounds();

      route.overview_path.forEach((point) => {
        bounds.extend(point);
      });

      mapRef.current.fitBounds(bounds, 80);

      // =====================================================
      // MONTA PATH DA ROTA
      // =====================================================

      const points = route.overview_path;

      let totalLat = 0;
      let totalLng = 0;
      let str = "";

      for (let i = 0; i < points.length; i++) {
        const lat = points[i].lat();
        const lng = points[i].lng();

        totalLat += lat;
        totalLng += lng;

        str += `(${lat},${lng})|`;
      }

      setPathRoutes(str.slice(0, -1));

      // =====================================================
      // CALCULA CENTRO DA ROTA
      // =====================================================

      const centerLat = totalLat / points.length;
      const centerLng = totalLng / points.length;

      setCenterLat(centerLat);
      setCenterLng(centerLng);

      if (mapRef.current) {
        mapRef.current.setCenter({
          lat: centerLat,
          lng: centerLng,
        });
      }

      // =====================================================
      // INICIA PULSAÇÃO
      // =====================================================

      iniciarPulsoRota();

      // =====================================================
      // ROTA GERADA
      // =====================================================

      setIsRouteGenarete(true);
    });
  }









  function DeleteRoute() {
    if (polylineRef.current) {
      polylineRef.current.setMap(null);
      polylineRef.current = null;
    }

    ArrayPoints = [];
    setIsRouteGenarete(false);

    for (let i = 0; i < inputs.length; i++) {
      const el = document.getElementById(`searchBox-${i}`);
      if (el) el.value = "";
    }
  }





  useEffect(() => {
    const savedDescricao = localStorage.getItem("descricao");
    if (savedDescricao) {
      setValues({ descricao: savedDescricao });
    }
  }, []);






  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    localStorage.setItem("descricao", value);
  };




  //BOTAO TOGGLE(ON-OFF)
  const handleChangeStatus = async (index) => {
    const id = valuesIndexStatus[index];

    // =========================================================
    // REFERÊNCIA SELECIONADA
    // =========================================================

    const referencia = referencias.find(
      (item) => item.id === id
    );

    if (!referencia) {
      console.error("❌ Referência não encontrada:", id);
      return;
    }

    const novoStatus = !valuesStatus[index];

    console.log("=================================");
    console.log("🔄 ALTERANDO STATUS");
    console.log("ID:", id);
    console.log("TIPO:", referencia.tipo);
    console.log("NOVO STATUS:", novoStatus);
    console.log("=================================");


    // =========================================================
    // ATUALIZA SWITCH IMEDIATAMENTE
    // =========================================================

    const novosStatus = [...valuesStatus];

    novosStatus[index] = novoStatus;

    setValuesStatus(novosStatus);


    try {

      // =======================================================
      // SALVA NO BACKEND
      // =======================================================

      await api.put(
        `referenciaStatus/${id}`,
        {
          status: novoStatus,
        },
        {
          headers: {
            inova: localStorage.getItem("inova"),
          },
        }
      );


      // =======================================================
      // ROTA
      // =======================================================

      if (String(referencia.tipo).toLowerCase() === "rota") {

        console.log(
          novoStatus
            ? "🟢 ATIVANDO ROTA"
            : "🔴 DESATIVANDO ROTA"
        );

        // Recarrega somente as rotas
        await fetchRotas();

        return;
      }


      // =======================================================
      // ÁREA
      // =======================================================

      const novasFormas = novoStatus
        ? [
          ...formasAtivas,
          referencia,
        ]
        : formasAtivas.filter(
          (forma) => forma.id !== id
        );

      setFormasAtivas(novasFormas);

      DrawFormas(novasFormas);

    } catch (error) {

      console.error(
        "❌ ERRO AO ALTERAR STATUS:",
        error
      );


      // =======================================================
      // ROLLBACK
      // =======================================================

      const statusRollback = [...valuesStatus];

      statusRollback[index] = !novoStatus;

      setValuesStatus(statusRollback);


      // Recarrega tudo do backend
      await atualizarReferencias();
    }
  };


  // retorna formas no mapa, conforme o backend
  const [formasAtivas, setFormasAtivas] = useState([]);

  //DESENHA O MAPA COM AS FORMAS
  const fetchFormas = async () => {
    const { data } = await api.get("/referenciass", {
      headers: { inova: localStorage.getItem("inova") },
    });

    const ativos = data.filter(
      (item) => item.ativo == true && item.apagado_em == null
    );

    setFormasAtivas(ativos);
    DrawFormas(ativos);
  };



  //FORMAS(OBJETOS) NO MAPA 
  const DrawFormas = (data) => {

    // =========================================================================================
    // VALIDA MAPA
    // =========================================================================================

    if (
      !mapRef.current ||
      !window.google ||
      !(mapRef.current instanceof window.google.maps.Map)
    ) {

      console.log("❌ mapa inválido no DrawFormas");

      return;
    }

    // =========================================================================================
    // GARANTE MAPA RENDERIZADO
    // =========================================================================================

    if (!mapRef.current.getBounds()) {

      console.log("❌ mapa ainda não renderizado (sem bounds)");

      return;
    }

    // =========================================================================================
    // LIMPA FORMAS ANTIGAS
    // =========================================================================================

    if (array_forms.length > 0) {

      array_forms.forEach((item) => {

        if (item.shape instanceof window.google.maps.InfoWindow) {

          item.shape.close();

        } else if (item.shape) {

          item.shape.setMap(null);

        }

      });

      array_forms = [];
    }

    // =========================================================================================
    // FILTRA SOMENTE O QUE ESSA TELA UTILIZA
    // =========================================================================================

    const formas = data.filter(
      (draw) => draw.tipo !== "ponto"
    );

    // =========================================================================================
    // DEBUG
    // =========================================================================================

    console.log("=================================");
    console.log("🔎 FORMAS PARA DESENHAR");
    console.log("TOTAL RECEBIDO:", data.length);
    console.log("TOTAL APÓS REMOVER PONTOS:", formas.length);

    const tipos = [...new Set(
      formas.map((item) => item.tipo)
    )];

    console.log("TIPOS ENCONTRADOS:", tipos);

    tipos.forEach((tipo) => {

      const quantidade = formas.filter(
        (item) => item.tipo === tipo
      ).length;

      console.log(
        `TIPO: "${tipo}" → ${quantidade} registros`
      );

    });

    console.log("=================================");

    // =========================================================================================
    // DESENHA AS FORMAS
    // =========================================================================================

    formas.forEach((draw) => {

      let center;

      let shape;

      // =======================================================================================
      // CÍRCULO
      // =======================================================================================

      if (draw.tipo === "circulo") {

        center = {

          lat: parseFloat(draw.lat),

          lng: parseFloat(draw.lon),

        };

        if (
          !Number.isFinite(center.lat) ||
          !Number.isFinite(center.lng)
        ) {

          console.warn(
            "⚠️ CÍRCULO COM COORDENADAS INVÁLIDAS:",
            draw.id,
            draw.descricao
          );

          return;
        }

        shape = new window.google.maps.Circle({

          strokeColor: draw.cor,

          strokeOpacity: 0.8,

          strokeWeight: 2,

          fillColor: draw.cor,

          fillOpacity: 0.35,

          map: mapRef.current,

          center,

          radius: parseFloat(draw.raio),

        });

      }

      // =======================================================================================
      // RETÂNGULO
      // =======================================================================================

      if (draw.tipo === "rectangule") {

        const bounds = {

          north: parseFloat(draw.north),

          south: parseFloat(draw.south),

          east: parseFloat(draw.east),

          west: parseFloat(draw.west),

        };

        if (
          !Number.isFinite(bounds.north) ||
          !Number.isFinite(bounds.south) ||
          !Number.isFinite(bounds.east) ||
          !Number.isFinite(bounds.west)
        ) {

          console.warn(
            "⚠️ RETÂNGULO COM COORDENADAS INVÁLIDAS:",
            draw.id,
            draw.descricao
          );

          return;
        }

        center = {

          lat: (bounds.north + bounds.south) / 2,

          lng: (bounds.east + bounds.west) / 2,

        };

        shape = new window.google.maps.Rectangle({

          strokeColor: draw.cor,

          strokeOpacity: 0.8,

          strokeWeight: 2,

          fillColor: draw.cor,

          fillOpacity: 0.35,

          map: mapRef.current,

          bounds,

        });

      }

      // =======================================================================================
      // POLYGON
      // =======================================================================================

      if (draw.tipo === "polygon") {

        try {

          if (!draw.obj_google) {

            console.warn(
              "⚠️ POLYGON SEM OBJ_GOOGLE:",
              draw.id,
              draw.descricao
            );

            return;
          }

          const paths =
            typeof draw.obj_google === "string"
              ? JSON.parse(draw.obj_google)
              : draw.obj_google;

          if (!Array.isArray(paths) || paths.length < 3) {

            console.warn(
              "⚠️ POLYGON INVÁLIDO:",
              draw.id,
              draw.descricao
            );

            return;
          }

          const polygonCoords = paths

            .map((coord) => ({

              lat: parseFloat(coord.lat),

              lng: parseFloat(coord.lng),

            }))

            .filter(
              (coord) =>
                Number.isFinite(coord.lat) &&
                Number.isFinite(coord.lng)
            );

          if (polygonCoords.length < 3) {

            console.warn(
              "⚠️ POLYGON SEM COORDENADAS SUFICIENTES:",
              draw.id,
              draw.descricao
            );

            return;
          }

          shape = new window.google.maps.Polygon({

            paths: polygonCoords,

            strokeColor: draw.cor || "#00aaff",

            strokeOpacity: 0.8,

            strokeWeight: 2,

            fillColor: draw.cor || "#00aaff",

            fillOpacity: 0.35,

            map: mapRef.current,

          });

          const bounds =
            new window.google.maps.LatLngBounds();

          polygonCoords.forEach((coord) => {

            bounds.extend(coord);

          });

          center = bounds.getCenter();

        } catch (error) {

          console.error(
            "❌ ERRO AO DESENHAR POLYGON:",
            {
              id: draw.id,

              descricao: draw.descricao,

              obj_google: draw.obj_google,

              erro: error,

            }
          );

          return;
        }
      }

      // =======================================================================================
      // SALVA SHAPE
      // =======================================================================================

      if (shape) {

        array_forms.push({

          id: draw.id,

          shape: shape,

        });

      }

      // =======================================================================================
      // INFOWINDOW
      // =======================================================================================

      if (center && shape) {

        const content = `

        <div class="custom-map-label ${draw.tipo}">
          
          <div class="custom-map-title">

            ${draw.descricao || "Sem nome"}

          </div>

          <div class="custom-map-subtitle">

            ${draw.tipo?.toUpperCase()}

          </div>

        </div>

      `;

        const infoWindow =
          new window.google.maps.InfoWindow({

            content,

            position: center,

            disableAutoPan: true,

          });

        // =====================================================================================
        // HOVER
        // =====================================================================================

        shape.addListener("mouseover", (e) => {

          if (e?.latLng) {

            infoWindow.setPosition(e.latLng);

          } else {

            infoWindow.setPosition(center);

          }

          infoWindow.open({

            map: mapRef.current,

          });

        });

        // =====================================================================================
        // MOUSE OUT
        // =====================================================================================

        shape.addListener("mouseout", () => {

          infoWindow.close();

        });

        // =====================================================================================
        // CLICK
        // =====================================================================================

        shape.addListener("click", () => {

          // ===============================================================================
          // DESATIVA FORMA ANTERIOR
          // ===============================================================================

          if (
            editingShape &&
            editingShape !== shape
          ) {

            if (editingShape.setEditable) {

              editingShape.setEditable(false);

            }

            if (editingShape.setDraggable) {

              editingShape.setDraggable(false);

            }

            editingShape.setOptions({

              strokeWeight: 2,

              fillOpacity: 0.35,

            });

          }

          console.log("CLICOU NO OBJETO");

          // ===============================================================================
          // EDIÇÃO
          // ===============================================================================

          if (shape.setEditable) {

            shape.setEditable(true);

          }

          if (shape.setDraggable) {

            shape.setDraggable(true);

          }

          // ===============================================================================
          // HIGHLIGHT
          // ===============================================================================

          shape.setOptions({

            strokeWeight: 5,

            fillOpacity: 0.5,

          });

          // ===============================================================================
          // STATES
          // ===============================================================================

          setEditingShape(shape);

          setEditData({

            id: draw.id,

            nome: draw.descricao || "",

            cor:

              draw.cor === "red"

                ? "#ff0000"

                : draw.cor === "blue"

                  ? "#0000ff"

                  : draw.cor === "green"

                    ? "#00ff00"

                    : draw.cor === "yellow"

                      ? "#ffff00"

                      : draw.cor || "#3b82f6",

            tipo: draw.tipo,

          });

          setEditModalOpen(true);

          console.log("MODAL:", true);

          console.log("DATA:", {

            id: draw.id,

            nome: draw.descricao,

            cor: draw.cor,

            tipo: draw.tipo,

          });

        });

        // ===============================================================================
        // SALVA INFOWINDOW
        // ===============================================================================

        array_forms.push({

          id: draw.id,

          shape: infoWindow,

        });

      }

    });

    // =========================================================================================
    // DEBUG FINAL
    // =========================================================================================

 

  };

  const handleSubmit = async () => {


    function formatCoordinates(data) {
      return data
        .filter(
          (coord) =>
            coord &&
            coord.lat != null &&
            coord.lng != null
        )
        .map(
          (coord) =>
            `{${coord.lat},${coord.lng}}`
        )
        .join(",");
    }

    const formattedData =
      `{{${formatCoordinates(subT)}}}`;

    const submit = {
      lat: centerLat,
      lon: centerLng,
      obj_google: pathRoutes,
      descricao: values.descricao,
      tipo: "rota",
      cor: routeColor,
      north: formattedData,
      cliente: localStorage.getItem("id"),
    };

    console.log("SALVANDO ROTA:", submit);

    // =========================================================
    // LOADING
    // =========================================================

    Swal.fire({
      html: `
      <div style="
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        padding:10px 0;
      ">

        <div style="
          width:58px;
          height:58px;
          border-radius:16px;
          background:linear-gradient(
            135deg,
            #2563eb,
            #1d4ed8
          );
          display:flex;
          align-items:center;
          justify-content:center;
          margin-bottom:18px;
          box-shadow:
            0 10px 30px rgba(37,99,235,0.35);
        ">

          <div style="
            width:26px;
            height:26px;
            border:3px solid rgba(255,255,255,0.35);
            border-top:3px solid #ffffff;
            border-radius:50%;
            animation:spinRota .8s linear infinite;
          "></div>

        </div>

        <div style="
          font-size:21px;
          font-weight:700;
          color:#f8fafc;
          margin-bottom:8px;
        ">
          Salvando rota...
        </div>

        <div style="
          font-size:14px;
          color:#94a3b8;
          font-weight:500;
        ">
          Aguarde enquanto a rota é adicionada ao mapa.
        </div>

      </div>

      <style>
        @keyframes spinRota {
          to {
            transform: rotate(360deg);
          }
        }
      </style>
    `,

      background: `
      linear-gradient(
        180deg,
        #1e293b,
        #0f172a
      )
    `,

      width: 380,
      padding: "30px",

      showConfirmButton: false,

      allowOutsideClick: false,
      allowEscapeKey: false,

      customClass: {
        popup: "swal-modern-save"
      }
    });

    try {

      // =========================================================
      // 1. SALVA NO BACKEND
      // =========================================================

      console.log("📤 ENVIANDO ROTA...");

      await api.post(
        "/referenciaCreat",
        submit,
        {
          headers: {
            inova: localStorage.getItem("inova"),
          },
        }
      );

      console.log("✅ ROTA SALVA NO BACKEND");


      // =========================================================
      // 2. PARA O PISCAR DA ROTA TEMPORÁRIA
      // =========================================================

      if (routeBlinkIntervalRef.current) {
        clearInterval(routeBlinkIntervalRef.current);
        routeBlinkIntervalRef.current = null;
      }


      // =========================================================
      // 3. REMOVE A ROTA TEMPORÁRIA
      // =========================================================

      if (polylineRef.current) {
        polylineRef.current.setMap(null);
        polylineRef.current = null;
      }


      // =========================================================
      // 4. REMOVE OS PINS TEMPORÁRIOS
      // =========================================================

      routeMarkersRef.current.forEach((marker) => {
        if (marker) {
          marker.setMap(null);
        }
      });

      routeMarkersRef.current = [];


      // =========================================================
      // 5. REMOVE OS PINS DE PREVIEW
      // =========================================================

      routePreviewMarkersRef.current.forEach((marker) => {
        if (marker) {
          marker.setMap(null);
        }
      });

      routePreviewMarkersRef.current = [];


      // =========================================================
      // 6. RECARREGA MAPA + LISTA
      // =========================================================

      console.log("🔄 RECARREGANDO MAPA E LISTA...");

      await carregarAreasERotas();
      console.log("✅ MAPA E LISTA ATUALIZADOS");


      // =========================================================
      // 7. FINALIZA ESTADO DA ROTA
      // =========================================================

      setIsRouteGenarete(false);


      // =========================================================
      // 8. FECHA O LOADING SOMENTE AGORA
      // =========================================================

      Swal.close();

      toast.success("Rota salva com sucesso!");

      setFlagAdd(!flagAdd);
      setIsList(!isList);

    } catch (error) {

      console.error(
        "❌ ERRO AO SALVAR ROTA:",
        error
      );

      Swal.close();

      toast.error(
        error?.response?.data?.message ||
        "Erro ao salvar rota."
      );
    }
  };





  //=============================================
  //FUNÇÃO DELETAR
  //==============================================
  const handleDelete = async (id) => {
    try {
      await api.delete(`/referenciass/${id}`, {
        headers: {
          inova: localStorage.getItem("inova"),
        },
        data: {
          usuarioId: localStorage.getItem("idUsuario"),
        },
      });

      // ==========================================
      // REMOVE ROTAS DO MAPA
      // ==========================================
      array_routes.forEach((item) => {
        if (item.setMap) item.setMap(null);
        if (item.close) item.close();
      });

      array_routes = [];

      // ==========================================
      // REDESENHA SÓ AS ROTAS ATIVAS
      // ==========================================
      await fetchRotas();

      // ==========================================
      // REMOVE DA LISTA
      // ==========================================
      setRerefencias((prev) =>
        prev.filter((item) => item.id !== id)
      );

      // ==========================================
      // REMOVE SÓ DO MAPA
      // ==========================================
      array_forms = array_forms.filter((item) => {
        if (item.id === id) {

          // Trata InfoWindow
          if (
            item.shape instanceof window.google.maps.InfoWindow
          ) {
            item.shape.close();
          } else if (item.shape) {
            item.shape.setMap(null);
          }

          return false;
        }

        return true;
      });

      // ==========================================
      // FECHA MODAL
      // ==========================================
      closeModal();

      // ==========================================
      // INFORMA AO confirmDelete QUE DEU CERTO
      // ==========================================
      return true;

    } catch (error) {

      console.log("=================================");
      console.log("❌ ERRO AO EXCLUIR");
      console.log("=================================");

      console.log("ERRO:", error);
      console.log("STATUS:", error?.response?.status);
      console.log("DATA:", error?.response?.data);
      console.log("CODE:", error?.response?.data?.code);

      // ==========================================
      // ÁREA POSSUI ALERTA CADASTRADO
      // ==========================================
      if (
        error?.response?.data?.code === "AREA_COM_ALERTA"
      ) {

        await Swal.fire({
          background: "#0b1724",
          color: "#ffffff",
          width: "400px",
          padding: "30px",

          showConfirmButton: true,
          confirmButtonText: "Entendi",

          buttonsStyling: false,

          customClass: {
            popup: "swal-alerta-area",
            confirmButton: "swal-btn-alerta"
          },

          html: `
    <div class="swal-alerta-content">

      <!-- ÍCONE -->
      <div class="swal-alerta-icon">
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M10.3 3.3L2.6 17a2 2 0 001.7 3h15.4a2 2 0 001.7-3L13.7 3.3a2 2 0 00-3.4 0z"/>
          <path d="M12 9v4"/>
          <path d="M12 17h.01"/>
        </svg>
      </div>

      <!-- TÍTULO -->
      <div class="swal-alerta-title">
        Área não pode ser excluída
      </div>

      <!-- DESCRIÇÃO -->
      <div class="swal-alerta-description">
        Esta área possui um alerta cadastrado.
      </div>

      <!-- AVISO -->
      <div class="swal-alerta-info">

        <div class="swal-alerta-info-title">
          ALERTA VINCULADO
        </div>

        <div class="swal-alerta-info-text">
          Remova a notificação vinculada a esta área
          antes de excluí-la.
        </div>

      </div>

    </div>
  `,

          confirmButtonText: "Entendi"
        });

        // IMPORTANTE:
        // informa ao confirmDelete que NÃO excluiu
        return false;
      }

      // ==========================================
      // OUTROS ERROS
      // ==========================================
      await Swal.fire({
        icon: "error",
        title: "Erro ao excluir",
        text:
          error?.response?.data?.message ||
          "Ocorreu um erro inesperado.",
        confirmButtonText: "Entendi",
      });

      // Informa ao confirmDelete que não deu certo
      return false;
    }
  };






  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const atualizarReferencias = async () => {

    const { data } = await api.get("/referenciass", {
      headers: {
        inova: localStorage.getItem("inova"),
      },
    });

    // ===============================================================================================
    // REFERÊNCIAS
    // ===============================================================================================

    setRerefencias(data);

    // ===============================================================================================
    // STATUS
    // ===============================================================================================

    const objStatus = data.map((form) => form.ativo);

    const objIdStatus = data.map((form) => form.id);

    setValuesStatus(objStatus);

    setValuesIndexStatus(objIdStatus);

    // ===============================================================================================
    // FORMAS ATIVAS
    // ===============================================================================================

    const ativos = data.filter((item) => {

      const ativo =
        item.ativo === true ||
        item.ativo === "true" ||
        item.ativo === 1 ||
        item.ativo === "1" ||
        item.ativo === "t";

      return ativo && item.apagado_em == null;
    });

    // ===============================================================================================
    // STATE
    // ===============================================================================================

    setFormasAtivas(ativos);

    // ===============================================================================================
    // DESENHA FORMAS
    // ===============================================================================================

    DrawFormas(ativos);

    // ===============================================================================================
    // DESENHA ROTAS
    // ===============================================================================================

    await fetchRotas(data);
  };


  // SALVAR  AREA DESENHADA
  const handleButtonClick = async () => {

    // ===============================================================================================
    // VALIDAÇÕES
    // ===============================================================================================

    if (!drawnShapes.length) {
      toast.error("Desenhe uma área primeiro!");
      return;
    }

    if (!values.descricao.trim()) {
      toast.error("Informe uma descrição para a área!");
      return;
    }


    // ===============================================================================================
    // PEGA O DESENHO ATUAL
    // ===============================================================================================

    const desenhoSalvo = drawnShapes[0];

    if (!desenhoSalvo) {
      toast.error("Desenhe uma área primeiro!");
      return;
    }

    // Pega a versão MAIS ATUAL do desenho no TerraDraw
    const snapshotAtual = terraDrawRef.current?.getSnapshot?.() || [];

    const featureAtual = snapshotAtual.find(
      (feature) => feature.id === desenhoSalvo.feature.id
    );

    // Se o desenho foi editado, usa o atualizado.
    // Caso contrário, usa o temporário salvo anteriormente.
    const feature = featureAtual || desenhoSalvo.feature;

    const tipo = desenhoSalvo.type;
    const cor = desenhoSalvo.color;

    console.log("💾 DESENHO ATUAL PARA SALVAR:", feature);


    // ===============================================================================================
    // NOME DO TIPO
    // ===============================================================================================

    const tiposExibicao = {
      circle: "Círculo",
      polygon: "Polígono",
      rectangle: "Retângulo",
    };

    const tipoExibicao =
      tiposExibicao[tipo] || tipo;


    // ===============================================================================================
    // CONFIRMAÇÃO
    // ===============================================================================================

    const result = await Swal.fire({

      background: "rgba(15, 23, 42, 0.96)",

      color: "#ffffff",

      width: "420px",

      padding: "28px",

      showCancelButton: true,

      confirmButtonText: "Salvar",

      cancelButtonText: "Cancelar",

      reverseButtons: true,

      buttonsStyling: false,

      customClass: {

        popup: "swal-map-popup",

        confirmButton: "swal-map-confirm",

        cancelButton: "swal-map-cancel",

      },

      html: `

      <div class="swal-map-wrapper">

        <!-- =========================================================
             ÍCONE
        ========================================================== -->

        <div class="swal-map-icon">

          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >

            <path
              d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"
            />

            <circle
              cx="12"
              cy="10"
              r="2.5"
            />

          </svg>

        </div>


        <!-- =========================================================
             TÍTULO
        ========================================================== -->

        <div class="swal-map-title">
          Salvar área?
        </div>


        <!-- =========================================================
             SUBTÍTULO
        ========================================================== -->

        <div class="swal-map-subtitle">
          Confirme os dados antes de salvar esta referência.
        </div>


        <!-- =========================================================
             DADOS
        ========================================================== -->

        <div class="swal-map-card">

          <div class="swal-map-row">

            <span class="swal-label">
              Tipo
            </span>

            <span class="swal-value">
              ${tipoExibicao}
            </span>

          </div>


          <div class="swal-divider"></div>


          <div class="swal-map-row">

            <span class="swal-label">
              Descrição
            </span>

            <span class="swal-value descricao">
              ${values.descricao || "Sem descrição"}
            </span>

          </div>

        </div>

      </div>

    `,
    });


    // ===============================================================================================
    // CANCELADO
    // ===============================================================================================

    if (!result.isConfirmed) {

      console.log("❌ SALVAMENTO CANCELADO");
      console.log("✏️ DESENHO MANTIDO");
      console.log("🔓 MODO DE EDIÇÃO");

      if (terraDrawRef.current) {

        // Volta para o modo de seleção/edição
        terraDrawRef.current.setMode("select");

        console.log(
          "🛠️ MODO ATUAL:",
          terraDrawRef.current.getMode()
        );

        console.log(
          "📸 SNAPSHOT ATUAL:",
          terraDrawRef.current.getSnapshot()
        );
      }

      return;
    }


    // ===============================================================================================
    // LOADING
    // ===============================================================================================

    Swal.fire({

      html: `

      <div class="swal-loading-content">

        <div class="swal-loading-icon">

          <div class="swal-loading-spinner"></div>

        </div>


        <div class="swal-loading-title">
          Salvando área...
        </div>


        <div class="swal-loading-subtitle">
          Processando referência
        </div>

      </div>

    `,

      showConfirmButton: false,

      allowOutsideClick: false,

      allowEscapeKey: false,

      background: "#0b1724",

      color: "#ffffff",

      width: "360px",

      padding: "30px",

      customClass: {

        popup: "swal-loading-modern"

      }

    });


    try {

      // =============================================================================================
      // MONTA OBJETO BASE
      // =============================================================================================

      const data = {

        tipo: null,

        cor: cor,

        descricao: values.descricao.trim(),

      };


      // =============================================================================================
      // CÍRCULO
      // =============================================================================================

      if (tipo === "circle") {

        console.log("⭕ CONVERTENDO CÍRCULO");


        const coordinates =
          feature.geometry.coordinates[0];


        // Remove último ponto porque ele é igual ao primeiro
        const pontos =
          coordinates.slice(0, -1);


        if (!pontos.length) {

          throw new Error(
            "Círculo sem coordenadas."
          );

        }


        // ===========================================================================================
        // CALCULA CENTRO
        // ===========================================================================================

        let somaLat = 0;

        let somaLng = 0;


        pontos.forEach(([lng, lat]) => {

          somaLat += lat;

          somaLng += lng;

        });


        const lat =
          somaLat / pontos.length;


        const lon =
          somaLng / pontos.length;


        // ===========================================================================================
        // CALCULA RAIO
        // ===========================================================================================

        const primeiroPonto =
          pontos[0];


        const lat2 =
          primeiroPonto[1];


        const lon2 =
          primeiroPonto[0];


        const toRadians = (value) =>
          (value * Math.PI) / 180;


        const R = 6371000;


        const dLat =
          toRadians(lat2 - lat);


        const dLon =
          toRadians(lon2 - lon);


        const a =
          Math.sin(dLat / 2) ** 2 +

          Math.cos(toRadians(lat)) *

          Math.cos(toRadians(lat2)) *

          Math.sin(dLon / 2) ** 2;


        const c =
          2 *
          Math.atan2(
            Math.sqrt(a),
            Math.sqrt(1 - a)
          );


        const raio =
          R * c;


        console.log("📍 LAT:", lat);

        console.log("📍 LON:", lon);

        console.log("⭕ RAIO:", raio);


        data.tipo = "circulo";

        data.lat = lat;

        data.lon = lon;

        data.raio = raio;


        // Mantém compatibilidade com o backend
        data.obj_google = {

          lat: lat,

          lon: lon,

          raio: raio,

        };

      }


      // =============================================================================================
      // POLÍGONO
      // =============================================================================================

      else if (String(tipo).trim().toLowerCase() === "polygon") {
        console.log("🔷 CONVERTENDO POLÍGONO");

        const coordinates = feature.geometry.coordinates[0];

        const path = coordinates.map(([lng, lat]) => ({
          lat: lat,
          lng: lng,
        }));

        console.log("📍 PATH:", path);

        data.tipo = "polygon";

        data.obj_google = JSON.stringify(path);
      }


      // =============================================================================================
      // RETÂNGULO
      // =============================================================================================

      else if (tipo === "rectangle") {

        console.log("⬛ CONVERTENDO RETÂNGULO");


        const coordinates =
          feature.geometry.coordinates[0];


        const pontos =
          coordinates.slice(0, -1);


        if (!pontos.length) {

          throw new Error(
            "Retângulo sem coordenadas."
          );

        }


        const lngs =
          pontos.map(([lng]) => lng);


        const lats =
          pontos.map(([, lat]) => lat);


        const north =
          Math.max(...lats);


        const south =
          Math.min(...lats);


        const east =
          Math.max(...lngs);


        const west =
          Math.min(...lngs);


        console.log("⬆️ NORTH:", north);

        console.log("⬇️ SOUTH:", south);

        console.log("➡️ EAST:", east);

        console.log("⬅️ WEST:", west);


        data.tipo = "rectangule";


        data.obj_google = {

          north: north,

          east: east,

          south: south,

          west: west,

        };

      }


      // =============================================================================================
      // TIPO INVÁLIDO
      // =============================================================================================

      else {

        throw new Error(
          `Tipo de desenho inválido: ${tipo}`
        );

      }


      // =============================================================================================
      // DEBUG FINAL
      // =============================================================================================

      console.log(
        "📤 DADOS ENVIADOS AO BACKEND:"
      );

      console.log(data);


      console.log(
        "📤 PAYLOAD JSON:",
        JSON.stringify(data, null, 2)
      );


      // =============================================================================================
      // POST
      // =============================================================================================

      const response = await api.post(

        "/referenciaCreat",

        data,

        {

          headers: {

            inova:
              `Bearer ${localStorage.getItem("inova")}`

          }

        }

      );


      console.log(
        "📤 ENVIANDO PARA /referenciaCreat..."
      );


      console.log(
        "✅ ÁREA SALVA:",
        response.data
      );


      // =============================================================================================
      // RECARREGA REFERÊNCIAS
      // =============================================================================================

      console.log(
        "🔄 RECARREGANDO REFERÊNCIAS..."
      );


      await carregarAreasERotas();


      console.log(
        "✅ REFERÊNCIAS RECARREGADAS"
      );


      // =============================================================================================
      // FECHA LOADING
      // =============================================================================================

      Swal.close();


      // =============================================================================================
      // SUCESSO
      // =============================================================================================

      await Swal.fire({

        html: `

        <div class="swal-success-content">

          <div class="swal-success-icon">

            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >

              <path d="M20 6L9 17L4 12"/>

            </svg>

          </div>


          <div class="swal-success-title">
            Área salva com sucesso!
          </div>


          <div class="swal-success-subtitle">
            A referência foi adicionada ao mapa.
          </div>

        </div>

      `,

        timer: 1400,

        showConfirmButton: false,

        background: "#0b1724",

        color: "#ffffff",

        width: "360px",

        padding: "30px",

        customClass: {

          popup: "swal-success-modern"

        }

      });


      // =============================================================================================
      // REMOVE O DESENHO DO TERRA DRAW
      // =============================================================================================

      if (
        terraDrawRef.current &&
        feature?.id
      ) {

        terraDrawRef.current.removeFeatures([
          feature.id
        ]);

      }


      // =============================================================================================
      // RESET
      // =============================================================================================

      drawnShapes = [];

      tipoDesenhoRef.current = null;

      setTipoSelecionado(null);

      setDesenhoCriado(false);


      // =============================================================================================
      // LIMPA DESCRIÇÃO
      // =============================================================================================

      setValues((prev) => ({

        ...prev,

        descricao: ""

      }));


      // =============================================================================================
      // VOLTA PARA STATIC
      // =============================================================================================

      if (terraDrawRef.current) {

        terraDrawRef.current.setMode("static");

      }


      console.log(
        "🔄 FORMULÁRIO RESETADO"
      );


    } catch (error) {

      console.error(
        "❌ ERRO COMPLETO:",
        error
      );


      console.error(
        "❌ STATUS:",
        error?.response?.status
      );


      console.error(
        "❌ RESPOSTA DO BACKEND:",
        error?.response?.data
      );


      console.error(
        "❌ MENSAGEM:",
        error?.message
      );


      Swal.close();


      // =============================================================================================
      // ERRO
      // =============================================================================================

      await Swal.fire({

        background:
          "rgba(15, 23, 42, 0.96)",

        width: "390px",

        padding: "28px",

        showConfirmButton: true,

        confirmButtonText: "Fechar",

        buttonsStyling: false,

        customClass: {

          popup: "swal-map-popup",

          confirmButton:
            "swal-map-error-confirm",

        },

        html: `

        <div class="swal-map-wrapper">

          <div class="swal-map-error-icon">

            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            >

              <circle
                cx="12"
                cy="12"
                r="9"
              />

              <path d="M12 8V12"/>

              <path d="M12 16H12.01"/>

            </svg>

          </div>


          <div class="swal-map-title">
            Erro ao salvar área
          </div>


          <div class="swal-map-subtitle">
            Não foi possível salvar esta referência.
          </div>


          <div class="swal-map-error-card">

            <div class="swal-map-error-message">

              Ocorreu um erro ao enviar os dados.
              Tente novamente.

            </div>

          </div>

        </div>

      `,

      });

    }

  };


  const toggleUI = () => {
    if (isList) {
      //  voltar
      setIsList(false);
      //  NÃO FECHA MAIS
    } else {
      //  entrar no add
      setIsList(true);
      setAberto(true);
    }
  };








  function handleClick(e) {
    e.preventDefault();
    setIsArea(false);

  }




  function handleClick34(e) {
    e.preventDefault();
    setIsArea(true);
  }


  // TIPOS DE DESENHO / CORES EM ÁREAS
  const handleCheckboxChange = (type) => {

    // =========================================================
    // JÁ EXISTE UM DESENHO
    // =========================================================

    if (desenhoCriado) {
      toast.warning(
        "Salve a área atual antes de criar uma nova."
      );

      return;
    }

    // =========================================================
    // TERRA DRAW
    // =========================================================

    if (!terraDrawRef.current) {
      console.error("❌ TERRA DRAW NÃO ESTÁ PRONTO");
      return;
    }

    // =========================================================
    // GUARDA TIPO
    // =========================================================

    tipoDesenhoRef.current = type;

    const cores = {
      red: "#ef4444",
      yellow: "#facc15",
      green: "#22c55e",
      blue: "#3b82f6",
    };

    const corSelecionada =
      cores[color] || "#3b82f6";

    console.log("🎨 COR SELECIONADA:", color);
    console.log("🎨 HEX:", corSelecionada);
    console.log("🔷 TIPO:", type);

    const options = {
      styles: {
        fillColor: corSelecionada,
        fillOpacity: 0.35,
        outlineColor: corSelecionada,
        outlineOpacity: 1,
        outlineWidth: 2,
      },
    };

    // =========================================================
    // ATIVA MODO
    // =========================================================

    if (type === "circle") {

      terraDrawRef.current.updateModeOptions(
        "circle",
        options
      );

      terraDrawRef.current.setMode("circle");

    } else if (type === "polygon") {

      terraDrawRef.current.updateModeOptions(
        "polygon",
        options
      );

      terraDrawRef.current.setMode("polygon");

    } else if (type === "rectangle") {

      terraDrawRef.current.updateModeOptions(
        "rectangle",
        options
      );

      terraDrawRef.current.setMode("rectangle");

    } else {

      terraDrawRef.current.setMode("static");
    }
  };


  //REMOVE PONTO DE ROTA
  const removeInput = async (indexToRemove) => {

    const result = await Swal.fire({

      title: "Remover ponto?",

      text: "Este ponto será removido da rota.",

      icon: "warning",

      background: "#0f172a",

      color: "#ffffff",

      showCancelButton: true,

      reverseButtons: true,

      confirmButtonText: "Remover",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#ef4444",

      cancelButtonColor: "#334155",

      customClass: {
        popup: "swal-delete-ref",
        confirmButton: "swal-btn-delete",
        cancelButton: "swal-btn-cancel"
      }
    });

    // Cancelou
    if (!result.isConfirmed) {
      console.log("❌ SALVAMENTO CANCELADO");

      terraDrawRef.current?.setMode("select");

      console.log("🔓 MODO DE EDIÇÃO ATIVADO");

      return;
    }

    // Remove ponto

    setInputs(
      inputs.filter(
        (_, index) => index !== indexToRemove
      )
    );

    // Feedback sucesso
    Swal.fire({

      icon: "success",

      title: "Ponto removido",

      text: "O ponto foi removido da rota.",

      background: "#0f172a",

      color: "#ffffff",

      timer: 1800,

      showConfirmButton: false
    });
  };


  //BOTAO VERIFICAR SE HÁ ALGUMA DESTINO E ORIGEM 
  const handleGenerateRoute = async () => {

    // Valida descrição
    if (!values.descricao?.trim()) {

      await Swal.fire({

        icon: "warning",

        title: "Descrição obrigatória",

        text: "Informe uma descrição para gerar a rota.",

        background: "#0f172a",

        color: "#ffffff",

        confirmButtonColor: "#2563eb"
      });

      return;
    }

    // Verifica se todos os inputs possuem valor
    const inputsVazios = inputs.some((_, index) => {

      const el = document.getElementById(
        `searchBox-${index}`
      );

      return !el?.value?.trim();
    });

    // Se existir algum campo vazio
    if (inputsVazios) {

      await Swal.fire({

        icon: "warning",

        title: "Campos obrigatórios",

        text: "Preencha origem, destino e todas as paradas antes de gerar a rota.",

        background: "#0f172a",

        color: "#ffffff",

        confirmButtonColor: "#2563eb"
      });

      return;
    }

    // Gera rota
    calcRoute();
  };


  // //carregando mapa
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (window.google && window.google.maps) {
  //       clearInterval(interval);
  //       window.initMap();
  //     }
  //   }, 300);

  //   return () => clearInterval(interval);
  // }, []);

  const [tipoSelecionado, setTipoSelecionado] = useState(null);
  const [desenhoCriado, setDesenhoCriado] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);





  //SALVAR ALTERAÇÕES EM AREAS 
  const handleSaveEdit = async () => {
    if (savingEdit) return;

    setSavingEdit(true);

    console.log("CLICOU SALVAR");

    try {

      console.log("ENTROU TRY");

      // ===================================================================================
      // VALIDAÇÕES
      // ===================================================================================

      if (!editingShape) {

        console.log("SEM editingShape");

        return;
      }

      if (!editData) {

        console.log("SEM editData");

        return;
      }

      console.log("TEM DADOS");

      // ===================================================================================
      // BASE
      // ===================================================================================

      let data = {

        id: editData.id,

        descricao: editData.nome,

        cor: editData.cor,

        tipo: editData.tipo,
      };

      console.log("DATA BASE:", data);

      // ===================================================================================
      // CIRCULO
      // ===================================================================================

      if (editingShape instanceof window.google.maps.Circle) {

        console.log("TIPO: CIRCULO");

        const center = editingShape.getCenter();

        data.lat = center.lat();

        data.lon = center.lng();

        data.raio = editingShape.getRadius();
      }

      // ===================================================================================
      // RECTANGLE
      // ===================================================================================

      if (editingShape instanceof window.google.maps.Rectangle) {

        console.log("TIPO: RECTANGLE");

        const bounds = editingShape.getBounds();

        data.north = bounds.getNorthEast().lat();

        data.east = bounds.getNorthEast().lng();

        data.south = bounds.getSouthWest().lat();

        data.west = bounds.getSouthWest().lng();
      }

      // ===================================================================================
      // POLYGON
      // ===================================================================================

      if (editingShape instanceof window.google.maps.Polygon) {

        console.log("TIPO: POLYGON");
        let path = editingShape
          .getPath()
          .getArray()
          .map((p) => ({

            lat: p.lat(),

            lng: p.lng(),
          }));

        // FECHA POLYGON

        path.push(path[0]);
        data.obj_google = JSON.stringify(path);


      }

      // ===================================================================================
      // LOG FINAL
      // ===================================================================================

      console.log("SALVANDO FINAL:", data);
      Swal.fire({

        html: `

    <div style="
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content:center;
      padding-top:8px;
    ">

      <div style="
        width:52px;
        height:52px;
        border-radius:16px;
        background:linear-gradient(
          135deg,
          #2563eb,
          #1d4ed8
        );
        display:flex;
        align-items:center;
        justify-content:center;
        box-shadow:
          0 10px 30px rgba(37,99,235,0.35);
        margin-bottom:18px;
      ">

        <div style="
          width:24px;
          height:24px;
          border:3px solid rgba(255,255,255,0.35);
          border-top:3px solid #fff;
          border-radius:50%;
          animation:spinSwal .8s linear infinite;
        "></div>

      </div>

      <div style="
        font-size:22px;
        font-weight:700;
        color:#f8fafc;
        margin-bottom:8px;
      ">

        Salvando alterações

      </div>

      <div style="
        font-size:14px;
        color:#94a3b8;
        font-weight:500;
      ">

        Atualizando referência no mapa

      </div>

    </div>

    <style>

      @keyframes spinSwal{

        to{

          transform:rotate(360deg);
        }
      }

    </style>
  `,

        background: `
    linear-gradient(
      180deg,
      #1e293b,
      #0f172a
    )
  `,

        width: 380,

        padding: "30px",

        showConfirmButton: false,

        allowOutsideClick: false,

        customClass: {

          popup: "swal-modern-save"
        }
      });

      // ===================================================================================
      // API
      // ===================================================================================

      console.log("ENVIANDO API");
      await api.put(

        "/referenciaUpdate",

        data,

        {
          headers: {

            inova: `Bearer ${localStorage.getItem("inova")}`,
          }
        }
      );

      console.log("API OK");

      console.log("RESPONSE:");

      // ===================================================================================
      // FINALIZA EDIÇÃO
      // ===================================================================================

      if (editingShape.setEditable) {

        editingShape.setEditable(false);
      }

      if (editingShape.setDraggable) {

        editingShape.setDraggable(false);
      }

      editingShape.setOptions({

        strokeWeight: 2,

        fillOpacity: 0.35,

        fillColor: editData.cor,

        strokeColor: editData.cor,
      });

      // ===================================================================================
      // RESET STATES
      // ===================================================================================

      setEditingShape(null);

      setEditData(null);

      // ===================================================================================
      // FECHA MODAL
      // ===================================================================================

      setEditModalOpen(false);

      setSavingEdit(false);

      toast.success("Referência atualizada");
      Swal.close();

      // ===================================================================================
      // RELOAD
      // ===================================================================================

      atualizarReferencias();

    } catch (error) {
      setSavingEdit(false);

      Swal.close();

      console.log("ERRO HANDLE SAVE:");

      console.log(error);

      console.log(error?.response);

      console.log(error?.response?.data);

      toast.error("Erro ao atualizar referência");
    }
  };

  return (
    <div className="box-container rotas-areas-page">

      <ToastContainer />

      {/* =========================================================
        MAPA
    ========================================================= */}

      <div
        ref={mapContainerRef}
        className="configMap area-rota"
        id="map"
      />

      {/* =========================================================
        LOADER
    ========================================================= */}

      {carregandoAreasRotas && (
        <div className="loader-areas-rotas">
          <div className="loader-areas-spinner" />

          <div className="loader-areas-title">
            Carregando áreas e rotas
          </div>

          <div className="loader-areas-subtitle">
            Sincronizando os pontos do mapa
          </div>
        </div>
      )}

      {/* =========================================================
        PAINEL PRINCIPAL
    ========================================================= */}

      <div className="referencias-panel">

        {/* =======================================================
          HEADER
      ======================================================= */}

        <div className="referencias-header">

          <div className="referencias-header-info">

            <div className="referencias-header-title-row">

              <div className="referencias-header-icon">
                <MdLocationOn size={20} />
              </div>

              <div>
                <h5 className="referencias-title">
                  Pontos de referência
                </h5>

                <span className="referencias-subtitle">
                  Gerencie rotas e áreas do mapa
                </span>
              </div>

            </div>

          </div>

          <div className="referencias-header-actions">

            <button
              type="button"
              className="referencias-collapse-button"
              onClick={toggleDropdown}
              title={aberto ? "Recolher" : "Expandir"}
            >
              <IoMdArrowDropup
                size={24}
                style={{
                  transform: aberto
                    ? "rotate(180deg)"
                    : "rotate(90deg)",
                }}
              />
            </button>

            <button
              type="button"
              className="referencias-new-button"
              onClick={toggleUI}
            >
              {isList ? (
                <>
                  <FaArrowLeft size={15} />
                  <span>Voltar</span>
                </>
              ) : (
                <>
                  <MdAddLocationAlt size={18} />
                  <span>Novo</span>
                </>
              )}
            </button>

          </div>

        </div>

        {/* =======================================================
          CONTEÚDO
      ======================================================= */}

        <div
          className={`referencias-content ${aberto ? "referencias-content-open" : "referencias-content-closed"
            }`}
        >

          {isList ? (

            <div className="referencias-create-wrapper">

              {/* =================================================
                TABS
            ================================================= */}

              <nav className="referencias-tabs-wrapper">

                <div
                  className="nav nav-tabs referencias-tabs"
                  id="nav-tab"
                  role="tablist"
                >

                  <a
                    className="nav-item nav-link active referencias-tab"
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#nav-home"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                  >
                    <span className="referencias-tab-icon">
                      <MdAltRoute size={17} />
                    </span>

                    <span>Rota</span>
                  </a>

                  <a
                    className="nav-item nav-link referencias-tab"
                    id="nav-profile-tab"
                    data-toggle="tab"
                    href="#nav-profile"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                  >
                    <span className="referencias-tab-icon">
                      <MdCropSquare size={17} />
                    </span>

                    <span>Área</span>
                  </a>

                </div>

              </nav>

              {/* =================================================
                TAB CONTENT
            ================================================= */}

              <div
                className="tab-content referencias-tab-content"
                id="nav-tabContent"
              >

                {/* =================================================
                  ABA ROTA
              ================================================= */}

                <div
                  className="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >

                  <div className="rota-modern-form">

                    {/* =============================================
                      NOME
                  ============================================= */}

                    <div className="rota-modern-field">

                      <label className="rota-modern-label">
                        Nome
                      </label>

                      <div className="rota-modern-input-wrapper">

                        <input
                          className="rota-modern-input"
                          onChange={handleChange}
                          name="descricao"
                          placeholder="Digite uma descrição..."
                        />

                      </div>

                    </div>

                    {/* =============================================
                      COR
                  ============================================= */}

                    <div className="rota-modern-field">

                      <label className="rota-modern-label">
                        Cor da rota
                      </label>

                      <div className="rota-modern-color">

                        <div className="rota-modern-color-box">

                          <input
                            type="color"
                            value={routeColor}
                            onChange={(e) => {

                              const newColor = e.target.value;

                              setRouteColor(newColor);

                              // Atualiza linha imediatamente
                              if (polylineRef.current) {
                                polylineRef.current.setOptions({
                                  strokeColor: newColor,
                                });
                              }

                              // Atualiza pins
                              routeMarkersRef.current.forEach(
                                (marker) => {
                                  marker.setIcon(
                                    criarPinColorido(newColor)
                                  );
                                }
                              );

                              // Atualiza previews
                              routePreviewMarkersRef.current.forEach(
                                (marker) => {
                                  if (marker) {
                                    marker.setIcon(
                                      criarPinColorido(newColor)
                                    );
                                  }
                                }
                              );
                            }}
                            className="rota-modern-color-input"
                          />

                          <div
                            className="rota-modern-color-preview"
                            style={{
                              backgroundColor: routeColor,
                            }}
                          />

                          <div className="rota-modern-color-text">
                            <span>Cor selecionada</span>
                            <strong>{routeColor}</strong>
                          </div>

                        </div>

                      </div>

                    </div>

                    {/* =============================================
                      PONTOS
                  ============================================= */}

                    <div className="rota-modern-field">

                      <div className="rota-modern-label-row">

                        <label className="rota-modern-label">
                          Pontos da rota
                        </label>

                        <span className="rota-modern-counter">
                          {inputs.length} / 18
                        </span>

                      </div>

                      <div className="rota-modern-points">

                        {inputs.map((input, index) => (

                          <div
                            key={index}
                            className="rota-modern-point"
                          >

                            <div className="rota-modern-point-number">
                              {index + 1}
                            </div>

                            <input
                              id={`searchBox-${index}`}
                              className="rota-modern-point-input"
                              placeholder={
                                index === 0
                                  ? "Origem"
                                  : index === inputs.length - 1
                                    ? "Destino"
                                    : `Parada ${index}`
                              }
                            />

                            {/* Apenas paradas intermediárias */}
                            {index !== 0 &&
                              index !== inputs.length - 1 && (

                                <button
                                  type="button"
                                  className="rota-modern-remove"
                                  onClick={() => removeInput(index)}
                                  title="Remover ponto"
                                >
                                  <IoTrashOutline size={16} />
                                </button>

                              )}

                          </div>

                        ))}

                      </div>

                    </div>

                    {/* =============================================
                      AÇÕES
                  ============================================= */}

                    <div className="rota-modern-actions">

                      {/* =====================================================
      ADICIONAR PONTO
  ====================================================== */}

                      <button
                        type="button"
                        className="rota-modern-add-button"
                        onClick={addInput}
                        disabled={inputs.length > 17}
                      >
                        <span className="rota-modern-add-icon">
                          +
                        </span>

                        <span>
                          Adicionar ponto
                        </span>
                      </button>


                      <div className="rota-modern-actions-right">

                        {/* =================================================
        GERAR ROTA
    ================================================= */}

                        <button
                          type="button"
                          className="rota-modern-primary-button"
                          onClick={handleGenerateRoute}
                          disabled={isRouteGenarete}
                        >
                          <MdAltRoute size={18} />

                          <span>
                            {isRouteGenarete
                              ? "Rota gerada"
                              : "Gerar rota"}
                          </span>
                        </button>


                        {/* =================================================
        SALVAR ROTA
    ================================================= */}

                        <button
                          type="button"
                          className="rota-modern-primary-button"
                          onClick={handleSubmit}
                          disabled={!isRouteGenarete}
                        >
                          <MdCheck size={18} />

                          <span>
                            Salvar rota
                          </span>
                        </button>

                      </div>

                    </div>

                  </div>

                </div>

                {/* =================================================
                  ABA ÁREA
              ================================================= */}

                <div
                  className="tab-pane fade"
                  id="nav-profile"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                >

                  <form
                    className={`area-modern-form ${aberto ? "area-modern-form-open" : ""
                      }`}
                    id="myform"
                  >

                    {/* =============================================
                      DESCRIÇÃO
                  ============================================= */}

                    <div className="area-modern-field">

                      <label className="area-modern-label">
                        Nome da área
                      </label>

                      <input
                        type="text"
                        className="area-modern-input"
                        name="descricao"
                        onChange={handleChange}
                        value={values.descricao}
                        placeholder="Digite uma descrição..."
                      />

                    </div>

                    {/* =============================================
                      COR
                  ============================================= */}

                    <div className="area-modern-field">

                      <label className="area-modern-label">
                        Cor da área
                      </label>

                      <div className="area-modern-colors">

                        <label className="area-modern-color-option area-red">

                          <input
                            type="radio"
                            name="areaColor"
                            value="red"
                            checked={color === "red"}
                            onChange={handleColorChange}
                          />

                          <span className="area-modern-color-circle" />

                          <span>Vermelho</span>

                        </label>

                        <label className="area-modern-color-option area-yellow">

                          <input
                            type="radio"
                            name="areaColor"
                            value="yellow"
                            checked={color === "yellow"}
                            onChange={handleColorChange}
                          />

                          <span className="area-modern-color-circle" />

                          <span>Amarelo</span>

                        </label>

                        <label className="area-modern-color-option area-green">

                          <input
                            type="radio"
                            name="areaColor"
                            value="green"
                            checked={color === "green"}
                            onChange={handleColorChange}
                          />

                          <span className="area-modern-color-circle" />

                          <span>Verde</span>

                        </label>

                        <label className="area-modern-color-option area-blue">

                          <input
                            type="radio"
                            name="areaColor"
                            value="blue"
                            checked={color === "blue"}
                            onChange={handleColorChange}
                          />

                          <span className="area-modern-color-circle" />

                          <span>Azul</span>

                        </label>

                      </div>

                    </div>

                    {/* =============================================
                      TIPO DE DESENHO
                  ============================================= */}

                    <div className="area-modern-field">

                      <label className="area-modern-label">
                        Tipo de desenho
                      </label>

                      <div
                        className="area-modern-drawing-options"
                        id="drawingControls"
                      >

                        {/* CÍRCULO */}

                        <label
                          className={`area-modern-drawing-option ${tipoSelecionado === "circle"
                            ? "selected"
                            : ""
                            }`}
                        >

                          <input
                            type="checkbox"
                            checked={tipoSelecionado === "circle"}
                            disabled={desenhoCriado}
                            onChange={(e) => {

                              if (e.target.checked) {

                                console.log(
                                  "🟢 SELECIONOU CÍRCULO"
                                );

                                setTipoSelecionado("circle");

                                tipoDesenhoRef.current = "circle";

                                if (!terraDrawRef.current) {
                                  console.error(
                                    "❌ TERRA DRAW NÃO ESTÁ PRONTO"
                                  );
                                  return;
                                }

                                const cores = {
                                  red: "#ef4444",
                                  yellow: "#facc15",
                                  green: "#22c55e",
                                  blue: "#3b82f6",
                                };

                                const corSelecionada =
                                  cores[color] || "#3b82f6";

                                console.log(
                                  "🎨 COR DO CÍRCULO:",
                                  corSelecionada
                                );

                                terraDrawRef.current.updateModeOptions(
                                  "circle",
                                  {
                                    styles: {
                                      fillColor: corSelecionada,
                                      fillOpacity: 0.35,
                                      outlineColor: corSelecionada,
                                      outlineOpacity: 1,
                                      outlineWidth: 2,
                                    },
                                  }
                                );

                                console.log(
                                  "⚙️ MODE CIRCLE CONFIGURADO"
                                );

                                terraDrawRef.current.setMode(
                                  "circle"
                                );

                                console.log(
                                  "⭕ MODO CÍRCULO:",
                                  terraDrawRef.current.getMode()
                                );

                              } else {

                                setTipoSelecionado(null);

                                if (terraDrawRef.current) {
                                  terraDrawRef.current.setMode(
                                    "static"
                                  );
                                }

                                console.log(
                                  "🖱️ MODO CÍRCULO DESATIVADO"
                                );
                              }
                            }}
                          />

                          <span className="area-modern-drawing-icon">
                            ◯
                          </span>

                          <span>
                            Círculo
                          </span>

                        </label>

                        {/* POLÍGONO */}

                        <label
                          className={`area-modern-drawing-option ${tipoSelecionado === "polygon"
                            ? "selected"
                            : ""
                            }`}
                        >

                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={tipoSelecionado === "polygon"}
                            disabled={desenhoCriado}
                            onChange={(e) => {

                              if (e.target.checked) {

                                console.log(
                                  "🟢 SELECIONOU POLÍGONO"
                                );

                                setTipoSelecionado("polygon");

                                handleCheckboxChange("polygon");

                                console.log(
                                  "🔷 MODO POLÍGONO ATIVADO"
                                );

                              } else {

                                setTipoSelecionado(null);

                                if (terraDrawRef.current) {
                                  terraDrawRef.current.setMode(
                                    "static"
                                  );
                                }

                                console.log(
                                  "🖱️ MODO POLÍGONO DESATIVADO"
                                );
                              }
                            }}
                          />

                          <span className="area-modern-drawing-icon">
                            ⬡
                          </span>

                          <span>
                            Polígono
                          </span>

                        </label>

                        {/* RETÂNGULO */}

                        <label
                          className={`area-modern-drawing-option ${tipoSelecionado === "rectangle"
                            ? "selected"
                            : ""
                            }`}
                        >

                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              tipoSelecionado === "rectangle"
                            }
                            disabled={desenhoCriado}
                            onChange={(e) => {

                              if (e.target.checked) {

                                console.log(
                                  "🟢 SELECIONOU RETÂNGULO"
                                );

                                setTipoSelecionado("rectangle");

                                handleCheckboxChange(
                                  "rectangle"
                                );

                                console.log(
                                  "🟨 MODO RETÂNGULO ATIVADO"
                                );

                              } else {

                                setTipoSelecionado(null);

                                if (terraDrawRef.current) {
                                  terraDrawRef.current.setMode(
                                    "static"
                                  );
                                }

                                console.log(
                                  "🖱️ MODO RETÂNGULO DESATIVADO"
                                );
                              }
                            }}
                          />

                          <span className="area-modern-drawing-icon">
                            ▢
                          </span>

                          <span>
                            Retângulo
                          </span>

                        </label>

                      </div>

                    </div>

                    {/* =============================================
                      SALVAR ÁREA
                  ============================================= */}

                    <div className="area-modern-actions">

                      <button
                        type="button"
                        className="area-modern-save"
                        id="buttonDraw"
                        onClick={handleButtonClick}
                        disabled={!values.descricao.trim() || !desenhoCriado}
                      >
                        <MdCheck size={18} />

                        <span>
                          Salvar área
                        </span>
                      </button>

                      {!desenhoCriado && (
                        <div className="area-modern-required">
                          Desenhe uma área no mapa antes de salvar.
                        </div>
                      )}

                      {desenhoCriado && !values.descricao.trim() && (
                        <div className="area-modern-required">
                          Informe o nome da área.
                        </div>
                      )}

                    </div>

                  </form>

                </div>

              </div>

            </div>

          ) : (

            /* =====================================================
               LISTA DE REFERÊNCIAS
            ===================================================== */

            <div className="referencias-list-wrapper">

              {/* BUSCA */}

              <div className="referencias-search">

                <FiSearch
                  className="referencias-search-icon"
                />

                <input
                  type="text"
                  className="referencias-search-input"
                  placeholder="Buscar referência..."
                  value={referenciasSearchTerm}
                  onChange={(e) =>
                    setReferenciasSearchTerm(e.target.value)
                  }
                />

                {referenciasSearchTerm && (
                  <button
                    type="button"
                    className="referencias-search-clear"
                    onClick={() => setReferenciasSearchTerm("")}
                    title="Limpar busca"
                  >
                    ×
                  </button>
                )}

              </div>

              {/* LISTA */}

              <div className="ref-panel-list">

                {referencias
                  .filter((ref) => ref?.tipo !== "ponto")
                  .filter((ref) =>
                    (ref?.descricao || "")
                      .toLowerCase()
                      .includes(
                        referenciasSearchTerm.toLowerCase()
                      )
                  )
                  .map((ref, index) => (

                    <div
                      className="ref-panel-item"
                      key={ref.id}
                    >

                      <InfoReferencia
                        map={mapRef.current}
                        nome_referencia={ref.descricao}
                        latitude={ref.lat}
                        longitude={ref.lon}
                        center={ref.obj_google}
                        type={ref.tipo}
                        raio={ref.raio}
                        cor={ref.cor}
                        valor={valuesStatus[index]}
                        handleFunction={handleChangeStatus}
                        index={index}
                        referenciaId={ref.id}
                        activeModal={setIsOpen}
                        stateModal={modalIsOpen}
                        setConfirmRef={setConfirmRef}
                        handleDelete={handleDelete}

                        /* =================================================
              EDIÇÃO
          ================================================= */

                        setValues={setValues}
                        setColor={setColor}
                        color={color}
                        values={values}
                        setIsEditing={setIsEditing}
                        setEditingId={setEditingId}
                        setEditingShape={setEditingShape}
                        onDestacarRota={destacarRota}
                      />

                    </div>

                  ))}
                {/* 
                 =========================================================
                SEM RESULTADOS
                =========================================================  */}

                {referencias
                  .filter((ref) => ref?.tipo !== "ponto")
                  .filter((ref) =>
                    (ref?.descricao || "")
                      .toLowerCase()
                      .includes(
                        referenciasSearchTerm.toLowerCase()
                      )
                  ).length === 0 && (

                    <div className="ref-panel-empty">

                      <div className="ref-panel-empty-icon">
                        <FiSearch size={21} />
                      </div>

                      <strong className="ref-panel-empty-title">
                        Nenhuma referência encontrada
                      </strong>

                      <span className="ref-panel-empty-text">
                        Tente buscar por outro nome.
                      </span>

                    </div>

                  )}

              </div>

            </div>

          )}

        </div>

      </div>

      {/* =========================================================
        MODAL DE EDIÇÃO
    ========================================================= */}

      {editModalOpen && (

        <div className="map-edit-overlay">

          <div className="map-edit-modal">

            <div className="map-edit-header">

              <div className="map-edit-title-wrapper">

                <div className="map-edit-icon">
                  <MdEdit size={18} />
                </div>

                <div>

                  <div className="map-edit-title">
                    Editar referência
                  </div>

                  <span className="map-edit-subtitle">
                    Atualize os dados da referência
                  </span>

                </div>

              </div>

              <button
                type="button"
                className="map-edit-close"
                onClick={() => setEditModalOpen(false)}
              >
                ×
              </button>

            </div>

            {/* =====================================================
              NOME
          ===================================================== */}

            <div className="map-edit-group">

              <label>
                Nome
              </label>

              <input
                type="text"
                value={editData.nome}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    nome: e.target.value,
                  })
                }
              />

            </div>

            {/* =====================================================
              COR
          ===================================================== */}

            <div className="map-edit-group">

              <label>
                Cor
              </label>

              <div className="map-edit-color-wrapper">

                <input
                  type="color"
                  value={editData.cor}
                  onChange={(e) => {

                    const newColor = e.target.value;

                    setEditData({
                      ...editData,
                      cor: newColor,
                    });

                    // muda realtime
                    if (editingShape) {
                      editingShape.setOptions({
                        fillColor: newColor,
                        strokeColor: newColor,
                      });
                    }
                  }}
                />

                <span
                  className="map-edit-color-preview"
                  style={{
                    backgroundColor: editData.cor,
                  }}
                />

                <span className="map-edit-color-value">
                  {editData.cor}
                </span>

              </div>

            </div>

            {/* =====================================================
              SALVAR
          ===================================================== */}

            <button
              type="button"
              className="map-edit-save"
              onClick={handleSaveEdit}
            >
              <MdCheck size={18} />
              <span>Salvar alterações</span>
            </button>

          </div>

        </div>

      )}

    </div>
  );
}

export default PolygonsMaps;
